import React, {Fragment} from 'react';
import logo from '../../assets/svgs/vocal_centric_standalone.svg'

const LogoStandAlone = () => {
    return (
        <Fragment>
            <img src={logo} alt={'standalone'} />
        </Fragment>
    );
};

export default LogoStandAlone;